<!-- Success Modal -->
<!-- <ng-template #successContent let-modal> -->
<div class="modal-content">
  <div class="modal-header">
      <button type="button" class="btn-close"aria-label="Close" id="btn-close"></button>
  </div>
  <div class="modal-body text-center">
    <lord-icon src="https://cdn.lordicon.com/lupuorrc.json" trigger="loop" colors="primary:#0ab39c,secondary:#405189" style="width:120px;height:120px"></lord-icon>
    <div class="mt-4 pt-2 fs-15">
        <h4>{{title | translate}}</h4>
        <p class="text-muted mx-4 mb-0">{{subTitle | translate}}</p>
    </div>
    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="swal2-cancel btn btn-primary w-xs mb-1" aria-label="" style="display: inline-block;" (click)="close()">Back</button>
    </div>
  </div>
</div><!-- /.modal-content -->
<!-- </ng-template> -->